<template>
  <transition name="fade">
    <div class="login-container">
      <div class="login-wrapper">
        <div class="login-title">LOGIN</div>
        <div style="margin-top:20px">
          <div class="login-input">
            <label for="">Email</label>
            <input
              style="border: 1px solid grey"
              type="email"
              placeholder="cth: nama@email.com"
              v-model="email"
              @keyup.enter="runLogin"
            />
          </div>
          <div class="login-input">
            <label for="">Password</label>
            <input
              style="border: 1px solid grey"
              type="password"
              placeholder="******"
              v-model="password"
              @keyup.enter="runLogin"
            />
          </div>
        </div>
        <div class="one-btn-center">
          <div class="btn-small">
            <div
              class="btn-wrapper btn-wrapper__transparent-red"
              @click="closeModal()"
            >
              Batal
            </div>
          </div>
          <div class="btn-small">
            <div
              class="btn-wrapper btn-wrapper__transparent-red"
              @click="runLogin"
            >
              Login
            </div>
          </div>
        </div>
        <div class="btn-link-wrapper">
          <div class="btn-link" @click="forgot()">Lupa Password</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  data() {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('SET_MODAL_LOGIN', false)
    },
    forgot() {
      this.closeModal()
      this.$store.commit('SET_MODAL_FORGOT', true)
    },
    async runLogin() {
      const self = this
      const url = `${api}/api/v1/auth`
      const authData = {
        email: this.email,
        password: this.password,
      }

      this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      try {
        const { data: auth } = await axios({
          method: 'POST',
          url,
          data: authData,
        })

        if (auth && auth.data) {
          this.$store.commit('SET_TOKEN', auth.data.token)
          this.$store.commit('SET_PERMISSIONS', auth.data.permission)
          if (auth.data.kode && auth.data.kode.length > 0) {
            this.$store.commit('SET_KODE', auth.data.kode)
          }
          this.email = ''
          this.password = ''
          this.$store.commit('SET_MODAL_LOGIN', false)
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          this.$store.commit('AUTO_LOGIN')
          this.$router.push({ name: 'home' }, () => {})
        }
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Server Error')
        )
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
